import { createContext } from 'react';
import { createContextualCan } from '@casl/react';
import {
  PureAbility,
  ExtractSubjectType,
  Subject,
  SubjectRawRule,
} from '@casl/ability';

import { store } from '../store';
import { AuthState } from '../modules/auth';
import { HTTPMethod } from '../models';
import { SUPER_ADMIN } from '../constants';

export const ability = new PureAbility();

store.subscribe(() => {
  const auth = store.getState().auth;
  ability.update(defineRulesFor(auth));
});

const defineRulesFor = (auth: AuthState) => {
  const role = auth.userDetails?.role;

  const rules: SubjectRawRule<
    'GET' | 'POST' | 'PUT' | 'DELETE' | 'manage',
    ExtractSubjectType<Subject>,
    unknown
  >[] = [];

  if (role?.name === SUPER_ADMIN) {
    rules.push({
      action: 'manage',
      subject: 'all',
    });
  } else {
    role?.permission.forEach(permission => {
      permission.permissionActions.forEach(
        ({ action: { method, operationId }, enabled }) => {
          rules.push({
            action: method as HTTPMethod,
            subject: operationId,
            inverted: enabled === false,
          });
        }
      );
    });
  }
  return rules;
};

export const AbilityContext = createContext(ability);
export const Can = createContextualCan(AbilityContext.Consumer);
